// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wxAZe","largestCol":"styles_largestCol__1zEHe","smallestCol":"styles_smallestCol__1BAEg"};